<template>
 <v-alert
    text
    color="deep-orange"
>
    <span>
        {{ message }}
    </span>
    <!-- <v-text-field v-model="email"></v-text-field> -->
    <span>
        <v-btn
            text
            outlined
            color="deep-orange"
            @click="submit()"
        >
            Create
        </v-btn>
    </span>
</v-alert>
</template>

<script>
import API from '@/api';
const User = API.get('User');

export default {
    props: {
        user: {
            type: Object,
            default: () => {
                /**
                 * email
                 * mobile
                 */
                return {};
            }
        }
    },
    data: () => ({
        message: "User not found! Do you want to create user?",
        // email: "testUser20@fourello.com"
    }),
    methods: {
        async submit() {
            console.log(this.user)

            let form = {
                username: this.user.Email,
                email: this.user.Email,
                password: this.user.MobileNumber,
                full_name: this.user.FullName,
                mobile_number: this.user.MobileNumber,
                is_patient: true,
                height: this.user.Height,
                weight: this.user.Weight,
                gender: this.user.Gender,
                marital_status: this.user.CivilStatus,
                birth_date: this.user.birthdate
            };
            
            let apiResponse = {};

            await User.createUser(form)
                .then(response => {
                    console.log({ response })
                    apiResponse = {
                        response: response.data,
                        success: true
                    }
                })
                .catch(error => {
                    console.log(error.response.data)
                    let objectKey = Object.keys(error.response.data.errors)
                    console.log({ objectKey }, objectKey[0])
                    this.message = error.response.data.errors[objectKey[0]][0];
                    apiResponse = {
                        response: null,
                        success: false
                    }
                });

            console.log({ apiResponse });


            await this.$emit('submit', apiResponse);
        }
    }
}
</script>